/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BackupFileViewModel } from '../models/backup-file-view-model';
import { GetDatabaseBackupURL } from '../fn/developer/get-database-backup-url';
import { GetDatabaseBackupURL$Params } from '../fn/developer/get-database-backup-url';
import { GetS3BackupURL } from '../fn/developer/get-s-3-backup-url';
import { GetS3BackupURL$Params } from '../fn/developer/get-s-3-backup-url';
import { ListDatabaseBackups } from '../fn/developer/list-database-backups';
import { ListDatabaseBackups$Params } from '../fn/developer/list-database-backups';
import { ListS3Backups } from '../fn/developer/list-s-3-backups';
import { ListS3Backups$Params } from '../fn/developer/list-s-3-backups';
import { ListServerStatuses } from '../fn/developer/list-server-statuses';
import { ListServerStatuses$Params } from '../fn/developer/list-server-statuses';
import { ListServiceStatuses } from '../fn/developer/list-service-statuses';
import { ListServiceStatuses$Params } from '../fn/developer/list-service-statuses';
import { ListWebSiteRequests } from '../fn/developer/list-web-site-requests';
import { ListWebSiteRequests$Params } from '../fn/developer/list-web-site-requests';
import { ListWebSiteStatuses } from '../fn/developer/list-web-site-statuses';
import { ListWebSiteStatuses$Params } from '../fn/developer/list-web-site-statuses';
import { ListWebUrls } from '../fn/developer/list-web-urls';
import { ListWebUrls$Params } from '../fn/developer/list-web-urls';
import { ServerStatusViewModelPrimeDatatableResults } from '../models/server-status-view-model-prime-datatable-results';
import { ServiceStatusViewModelPrimeDatatableResults } from '../models/service-status-view-model-prime-datatable-results';
import { WebSiteRequestViewModelPrimeDatatableResults } from '../models/web-site-request-view-model-prime-datatable-results';
import { WebSiteStatusViewModelPrimeDatatableResults } from '../models/web-site-status-view-model-prime-datatable-results';
import { WebUrlViewModelPrimeDatatableResults } from '../models/web-url-view-model-prime-datatable-results';

@Injectable({ providedIn: 'root' })
export class DeveloperApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiDeveloperListServerStatusesPost()` */
  static readonly ApiDeveloperListServerStatusesPostPath = '/api/Developer/ListServerStatuses';

  /**
   * List Server Statuses.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListServerStatuses()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListServerStatuses$Response(params?: ListServerStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<ServerStatusViewModelPrimeDatatableResults>> {
    return ListServerStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * List Server Statuses.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListServerStatuses$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListServerStatuses(params?: ListServerStatuses$Params, context?: HttpContext): Observable<ServerStatusViewModelPrimeDatatableResults> {
    return this.ListServerStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<ServerStatusViewModelPrimeDatatableResults>): ServerStatusViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiDeveloperListServiceStatusesPost()` */
  static readonly ApiDeveloperListServiceStatusesPostPath = '/api/Developer/ListServiceStatuses';

  /**
   * List Service Statuses.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListServiceStatuses()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListServiceStatuses$Response(params?: ListServiceStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceStatusViewModelPrimeDatatableResults>> {
    return ListServiceStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * List Service Statuses.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListServiceStatuses$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListServiceStatuses(params?: ListServiceStatuses$Params, context?: HttpContext): Observable<ServiceStatusViewModelPrimeDatatableResults> {
    return this.ListServiceStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<ServiceStatusViewModelPrimeDatatableResults>): ServiceStatusViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiDeveloperListWebSiteStatusesPost()` */
  static readonly ApiDeveloperListWebSiteStatusesPostPath = '/api/Developer/ListWebSiteStatuses';

  /**
   * List Web Site Statuses.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListWebSiteStatuses()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListWebSiteStatuses$Response(params?: ListWebSiteStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<WebSiteStatusViewModelPrimeDatatableResults>> {
    return ListWebSiteStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * List Web Site Statuses.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListWebSiteStatuses$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListWebSiteStatuses(params?: ListWebSiteStatuses$Params, context?: HttpContext): Observable<WebSiteStatusViewModelPrimeDatatableResults> {
    return this.ListWebSiteStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<WebSiteStatusViewModelPrimeDatatableResults>): WebSiteStatusViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiDeveloperListWebSiteRequestsPost()` */
  static readonly ApiDeveloperListWebSiteRequestsPostPath = '/api/Developer/ListWebSiteRequests';

  /**
   * List Web Site Requests.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListWebSiteRequests()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListWebSiteRequests$Response(params?: ListWebSiteRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<WebSiteRequestViewModelPrimeDatatableResults>> {
    return ListWebSiteRequests(this.http, this.rootUrl, params, context);
  }

  /**
   * List Web Site Requests.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListWebSiteRequests$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListWebSiteRequests(params?: ListWebSiteRequests$Params, context?: HttpContext): Observable<WebSiteRequestViewModelPrimeDatatableResults> {
    return this.ListWebSiteRequests$Response(params, context).pipe(
      map((r: StrictHttpResponse<WebSiteRequestViewModelPrimeDatatableResults>): WebSiteRequestViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiDeveloperListWebUrlsPost()` */
  static readonly ApiDeveloperListWebUrlsPostPath = '/api/Developer/ListWebUrls';

  /**
   * List Web URLs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListWebUrls()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListWebUrls$Response(params?: ListWebUrls$Params, context?: HttpContext): Observable<StrictHttpResponse<WebUrlViewModelPrimeDatatableResults>> {
    return ListWebUrls(this.http, this.rootUrl, params, context);
  }

  /**
   * List Web URLs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListWebUrls$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListWebUrls(params?: ListWebUrls$Params, context?: HttpContext): Observable<WebUrlViewModelPrimeDatatableResults> {
    return this.ListWebUrls$Response(params, context).pipe(
      map((r: StrictHttpResponse<WebUrlViewModelPrimeDatatableResults>): WebUrlViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiDeveloperListDatabaseBackupsPost()` */
  static readonly ApiDeveloperListDatabaseBackupsPostPath = '/api/Developer/ListDatabaseBackups';

  /**
   * List Database Backups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListDatabaseBackups()` instead.
   *
   * This method doesn't expect any request body.
   */
  ListDatabaseBackups$Response(params?: ListDatabaseBackups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BackupFileViewModel>>> {
    return ListDatabaseBackups(this.http, this.rootUrl, params, context);
  }

  /**
   * List Database Backups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListDatabaseBackups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ListDatabaseBackups(params?: ListDatabaseBackups$Params, context?: HttpContext): Observable<Array<BackupFileViewModel>> {
    return this.ListDatabaseBackups$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BackupFileViewModel>>): Array<BackupFileViewModel> => r.body)
    );
  }

  /** Path part for operation `apiDeveloperGetDatabaseBackupUrlPost()` */
  static readonly ApiDeveloperGetDatabaseBackupUrlPostPath = '/api/Developer/GetDatabaseBackupURL';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetDatabaseBackupURL()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetDatabaseBackupURL$Response(params?: GetDatabaseBackupURL$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return GetDatabaseBackupURL(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetDatabaseBackupURL$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetDatabaseBackupURL(params?: GetDatabaseBackupURL$Params, context?: HttpContext): Observable<string> {
    return this.GetDatabaseBackupURL$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiDeveloperListS3BackupsPost()` */
  static readonly ApiDeveloperListS3BackupsPostPath = '/api/Developer/ListS3Backups';

  /**
   * List Database Backups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListS3Backups()` instead.
   *
   * This method doesn't expect any request body.
   */
  ListS3Backups$Response(params?: ListS3Backups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BackupFileViewModel>>> {
    return ListS3Backups(this.http, this.rootUrl, params, context);
  }

  /**
   * List Database Backups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListS3Backups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ListS3Backups(params?: ListS3Backups$Params, context?: HttpContext): Observable<Array<BackupFileViewModel>> {
    return this.ListS3Backups$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BackupFileViewModel>>): Array<BackupFileViewModel> => r.body)
    );
  }

  /** Path part for operation `apiDeveloperGetS3BackupUrlPost()` */
  static readonly ApiDeveloperGetS3BackupUrlPostPath = '/api/Developer/GetS3BackupURL';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetS3BackupURL()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetS3BackupURL$Response(params?: GetS3BackupURL$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return GetS3BackupURL(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetS3BackupURL$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetS3BackupURL(params?: GetS3BackupURL$Params, context?: HttpContext): Observable<string> {
    return this.GetS3BackupURL$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
